export const SERVICE_CENTER_ID = 'scId';
export const CONTACT = 'contact';
export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const VIN = 'vin';
